import React, { useState } from 'react';
import { Box, Container, CssBaseline, Stack, Typography, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import PageHeading from '../../global/header/PageHeading';
import WebcamCaptureDocWithSelfie from '../CameraComponents/WebcamCaptureDocWithSelfie';
// import DocumentWithSelfiePreview from './DocumentWithSelfiePreview';

import onBoardingEkycServices from '../../../services/onBoarding-ekyc-services';
import Loader from '../../global/Loader';
import { userDataFromLocal } from '../utils/getUserDetails';
import { getScreenShots } from '../utils/MakePdf';
import DialogMsgAction from '../../global/DialogMsgAction';
import DialogMsg from '../../global/DialogMsg';
import WebcamCaptureSimpleForMob from '../CameraComponents/WebcamCaptureSimpleForMobile';
import WebcamCaptureSimpleForMobile from '../CameraComponents/WebcamCaptureSimpleForMobile';
import { useTranslation } from 'react-i18next';

const { UploadImage, GetRetakes } = onBoardingEkycServices;

const DocumentWithSelfie = () => {
  const { t } = useTranslation();
  const [showFrontCamera, setShowFrontCamera] = useState(false); // camera show state
  const [showScreenshot, setShowScreenshot] = useState(false); // show screenshot after document with selfie capture state
  const [imgSrc, setImgSrc] = useState(null); // Captured image state for document with selfie window

  const handleClickOpen = () => {
    setShowFrontCamera(true);
  };

  // Dialog close button of camera
  const iconButtonHandler = (e) => {
    setShowFrontCamera(false);
  };
  // handle selfie continue
  const handleDocSelfieContinue = (imgSrc) => {
    setShowScreenshot(true);
    setShowFrontCamera(false);
    setImgSrc(imgSrc);
  };
  // handleDocSelfieRetake
  const handleDocSelfieRetake = () => {
    setShowFrontCamera(true);
  };

  return (
    <>
      {showFrontCamera ? (
        window.screen.width > 901 ? (
          <WebcamCaptureDocWithSelfie
            iconButtonHandler={iconButtonHandler}
            handleDocSelfieContinue={handleDocSelfieContinue}
          />
        ) : (
          <WebcamCaptureSimpleForMobile
            // imageSrc={imageSrc}
            // setImageSrc={setImageSrc}
            iconButtonHandler={iconButtonHandler}
            handleDocSelfieContinue={handleDocSelfieContinue}
            // setShowFrontCamera={setShowFrontCamera}
            // iconButtonHandler={iconButtonHandler}
            // fileMode="front"
            // heading={docName}
          />
        )
      ) : showScreenshot ? (
        <DocumentWithSelfiePreview imgSrc={imgSrc} handleDocSelfieRetake={handleDocSelfieRetake} />
      ) : (
        <>
          {/* <PageHeading pageTitle="Document with selfie" /> */}
          <PageHeading pageTitle={window.screen.width < 901 ? 'Selfie' : 'Document with Selfie'} />
          <Container maxWidth="lg" className="selfRegistrationContainer">
            <Box textAlign="center" mb={3}>
              <Box mb={3} className="imagePreviewBox">
                {window.screen.width < 901 ? (
                  <img
                    className="imagePreviewFrame2"
                    src="/static/selfieIcon.png"
                    alt="Document Preview"
                  />
                ) : (
                  <img
                    className="imagePreviewFrame2"
                    src="/static/documentSelfieW.svg"
                    alt="Document Preview"
                  />
                )}
              </Box>

              <Typography variant="h6" className="cameraTitle" mb={2}>
                {window.screen.width < 901 ? t('Capture selfie') : t('Capture document selfie')}
              </Typography>
              <Typography variant="body2" mb={3}>
                {window.screen.width < 901
                  ? t('Hold still and maintain a neutral expression when capturing the selfie')
                  : t('Make sure the document includes a picture of your face')}
              </Typography>
              <Link className="mainBtn" onClick={() => handleClickOpen()}>
                {t('Take a photo')}
              </Link>
            </Box>
          </Container>
        </>
      )}
    </>
  );
};

export default DocumentWithSelfie;

const DocumentWithSelfiePreview = ({ imgSrc, handleDocSelfieRetake }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [openloader, setOpenloader] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogeMsg, setOpenDialogeMsg] = useState(false);
  const [dialogMsg, setDialogMsg] = useState('');
  // const [uploadImageUrl, setUploadImageUrl] = useState(null);

  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get('id');
  const docName = urlParams.get('document_name');
  const ocrType = urlParams.get('ocrType');

  // function used to delay due to getscreenshot taking time as promise
  const UploadImageApiCallBack = async () => {
    // console.log('getCanvasgetCanvas', canvasId, type);

    const getCanvas = await getScreenShots('#sendWatermarkImage');
    getCanvas.toBlob(function (blob) {
      UploadImageApi(blob);
      // console.log('getCanvasgetCanvas', blob);
      const fileReader = new FileReader();
      // console.log('getCanvasgetCanvas', fileReader);
      fileReader.onload = function (event) {
        const base64String = event.target.result;
        // console.log('getCanvasgetCanvas', base64String);
        // UploadImageApi(base64String);
      };
      fileReader.readAsDataURL(blob);
    });
  };

  const UploadImageApi = async (watermarkFile) => {
    const newFile = new File([watermarkFile], `DocWithSelfie.jpg`, {
      type: 'image/jpg',
      lastModified: new Date().getTime()
    });
    // console.log('getCanvasgetCanvas', newFile);

    try {
      setOpenloader(true);
      const userData = userDataFromLocal();
      const applicationNo = userData?.applicationNo;
      const id = userData?.id;
      const formOcr = new FormData();
      formOcr.append('docId', id);
      formOcr.append('channelName', 'W');
      formOcr.append('docType', 'SelfiWDWaterMark'); // SelfiWDWaterMark
      formOcr.append('organizationId', 1);
      formOcr.append('applicationNo', applicationNo);
      formOcr.append('file', newFile ? newFile : null);
      formOcr.append('isWatermarked', true);
      formOcr.append('isBackendImage', false);

      const headerCredential = {
        languageId: 1,
        countryId: 1
      };

      const UploadImageResponse = await UploadImage(headerCredential, formOcr);
      if (
        UploadImageResponse.status === 'Success' &&
        Object.keys(UploadImageResponse.data).length > 0
      ) {
        // Check if 'existingJourney' exists in local storage, parse it from JSON, or initialize as an empty object
        let existingJourney = localStorage.getItem('journey');
        // If 'journey' already exists, parse it from JSON
        existingJourney = existingJourney ? JSON.parse(existingJourney) : {};
        // just code for mobile view to docWithSelfie and selfie
        let selfie = '';
        if (window.screen.width < 901) {
          selfie = {
            face_match_result: {
              selfie_doc_url: UploadImageResponse?.data?.doc_url,
              selfie_doc_name: UploadImageResponse?.data?.doc_name
            },
            selfieDocurl: UploadImageResponse?.data
          };
        }
        // just code for mobile view to docWithSelfie and selfie
        const newData = {
          ...existingJourney,
          docWithSelfie: UploadImageResponse.data,
          selfie // this key added for mobile view, beacuse it is by pass doc with selfie and selfie
        };
        localStorage.setItem('journey', JSON.stringify(newData));
        if (window.screen.width > 901) {
          navigate('/in/face-selfie'); // If window then redirect as it as flow
        } else {
          navigate('/in/personal-info'); // if mobile case then jump at personal info page, as suggested by Sanjay
        }
      } else {
        setOpenDialogeMsg(true);
        setDialogMsg(UploadImageResponse.message);
        // setDialogMsg('Something went wrong');
      }
    } catch (error) {
      console.log('errorerror', error);
    } finally {
      setOpenloader(false);
    }
  };
  // RetakeApi
  const RetakeApi = async () => {
    try {
      const GetRetakesResponse = await GetRetakes();
      if (GetRetakesResponse.status === 'Success') {
        navigate('/in/selfregistration');
      } else {
        setOpenDialogeMsg(true);
        setDialogMsg(GetRetakesResponse.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setOpenloader(false);
    }
  };

  // Error Dialog close handler
  const closeDialogMsgHandler = (e) => {
    setOpenDialogeMsg(false);
  };

  return (
    <>
      <Loader openloader={openloader} />
      <PageHeading pageTitle="Document selfie preview" />
      <Container maxWidth="lg" className="selfRegistrationContainer">
        <Box textAlign="center" mb={3}>
          <Box mb={3} className="imagePreviewBox patent">
            <img
              id="sendWatermarkImage"
              className="imagePreviewFrame"
              src={imgSrc}
              alt="Document With Selfie Preview"
            />
          </Box>
          <Box Container justifyContent="center" alignItems="center">
            {/* <Link className="mainBtn btnLink" to="/in/face-selfie"> */}
            <Button
              className="mainBtn"
              style={{ marginRight: '7px' }}
              onClick={UploadImageApiCallBack}
            >
              {t('Continue')}
            </Button>
            <Button
              className="mainBtn"
              onClick={() => {
                handleDocSelfieRetake();
                RetakeApi(); // retake api
              }}
            >
              {t('Retake')}
            </Button>
            {/* <Link className="mainBtn btnLink" to="/in/document-with-selfie">
              New shoot
            </Link> */}
          </Box>
        </Box>

        <DialogMsg
          openDialogeMsg={openDialogeMsg}
          dialogMsg={dialogMsg}
          dialogTitle="Alert"
          buttonText="Close"
          closeDialogMsgHandler={closeDialogMsgHandler}
        />

        {/* <DialogMsgAction
          openDialogeMsg={openDialog}
          dialogMsg={dialogMsg}
          dialogTitle="Confirmation"
          buttonText="Next"
          dialogMsgHandler={dialogMsgHandler}
          closeDialogMsgHandler={handleCloseConfirmBox}
        /> */}
      </Container>
    </>
  );
};
